var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"hide-details":"","label":"Config","outlined":"","dense":"","items":_vm.configs,"item-text":"name","item-value":"id","loading":_vm.$store.getters.configsIsLoading,"value":_vm.study.configId},on:{"change":_vm.setStudyConfig}})
}
var staticRenderFns = []

export { render, staticRenderFns }